<template>
  <v-card>
    <v-form @submit.prevent="true" v-model="valid" autocomplete="off">
      <v-container class="pt-3 pb-0">
        <h3>Bulk Add Responses</h3>
        <p>
          Field: <strong>{{ question.label || 'TBD' }}</strong>
        </p>

        <p>Place here all the responses you want to add. Every line would be a response</p>
        <v-textarea label="Responses" v-model="responses" autofocus clearable :rules="rules" no-resize rows="15"></v-textarea>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="success" :disabled="!valid" @click="add">Add</v-btn>
        <v-btn @click="close">Close</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  name: 'BulkAddAnswer',
  props: {
    question: Object
  },
  data() {
    return {
      responses: '',
      valid: false
    }
  },
  computed: {
    rules() {
      return [
        v => {
          return !v || !v.trim() ? 'Required' : true
        },
        v => {
          return v && v.split('\n').length > 100 ? 'No more than 100 values at a time' : true
        }
      ]
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    add() {
      const splittedResponses = this.responses.split('\n')
      const nonEmptyResponses = splittedResponses.filter(r => r && r.toString().trim()).map(r => r.toString().trim())
      this.$emit('add', nonEmptyResponses)
    }
  }
}
</script>
